/**
 * Rule context of the « Mes primes » page: the extranet base variables plus
 * `premiums_count`. Registrations pass {@link premiumsContextSchema} as
 * `contextVariables`, so the admin config page and the live
 * `RuleContextProvider` stay in lockstep.
 */

import type { ContextVariableDescriptor } from '@components/shared/configurable';

import {
  extranetBaseContextSchema,
  type ExtranetBaseContextKey,
} from '../../contextVariables';

export const premiumsContextSchema = {
  ...extranetBaseContextSchema,
  premiums_count: {
    type: 'number',
    description:
      'Number of premiums returned by WS2_EA_TAB_QUI for the session and the current search / situation filter (undefined while loading or on error).',
  },
} as const satisfies Record<string, ContextVariableDescriptor>;

export type PremiumsContextKey = keyof typeof premiumsContextSchema;

/** Page bag = base bag + `premiums_count`. Plain function, memoised by the page. */
export function buildPremiumsRuleContext(
  base: Record<ExtranetBaseContextKey, unknown>,
  premiumsCount: number | undefined,
): Record<PremiumsContextKey, unknown> {
  return { ...base, premiums_count: premiumsCount };
}
